import React from "react";

export const ChevronLeftIcon = ({ className = "w-4 h-4" }) => (
  <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <path d="M12.5 15L7.5 10L12.5 5" />
  </svg>
);

export const ChevronRightIcon = ({ className = "w-4 h-4" }) => (
  <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <path d="M7.5 5L12.5 10L7.5 15" />
  </svg>
);

export const ExpandIcon = ({ className = "w-4 h-4" }) => (
  <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <path d="M7.5 3.5H3.5V7.5" />
    <path d="M12.5 16.5H16.5V12.5" />
    <path d="M3.5 3.5L8.25 8.25" />
    <path d="M16.5 16.5L11.75 11.75" />
  </svg>
);

export const CloseIcon = ({ className = "w-5 h-5" }) => (
  <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <path d="M5 5L15 15" />
    <path d="M15 5L5 15" />
  </svg>
);
